import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  onClick: () => void;
}

export default function AddAccountButton({ onClick }: Props) {
  const intl = useIntl();

  return (
    <div className="mt-4">
      <button
        type="button"
        onClick={onClick}
        aria-label={intl.formatMessage({ id: 'accounts.list.create' })}
        className="inline-flex items-center gap-2 rounded-xl border-2 border-dashed border-slate-300 px-4 py-2.5 text-sm font-medium text-slate-500 transition hover:border-brand-400 hover:text-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-300"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        <FormattedMessage id="accounts.list.create" />
      </button>
    </div>
  );
}
